// removed by extract-text-webpack-plugin
module.exports = {"loader":"dh-stemning-loader","anim":"dh-stemning-anim"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Loader/Loader.css
// module id = 62
// module chunks = 0 1